// removed by extract-text-webpack-plugin
module.exports = {"component":"uE8NhqE-wevdVqvEJzK-2","loginPic":"_1pflU5ULyWGfo60xO_N-Vr","loginMes":"_27w-_r7Ceb3ldoFZeY-Sf1","loginH1":"_1teEbTDOc75tZSMenY2cr4","bottomContainer":"_3U3Nfa3KnjRiZBGfnKsGvG","btn":"_1ZWGjH3SmKTGou3jJ_3tAc","imgBtn":"_2ZLLZVgcOZC11f8CqZZkGg","newImgBtn":"_1dkAIh502xMpc23xN5qPOH","newBtn":"_23-hfcHYe2eVHp9iBFSRaa","helpDiv":"_3I6AJ0h3eChLgawVgQ6mRO","mt15":"_2dAUpCYfZVr7J15wX7tFTU","ml7":"_2W-3Hbayw2Ufhm2Db6nYja","mr35":"_3NUiNmJv4hAmZAEDS2UASl","helpbtn":"_5Hqz5Asj09fdXU_rRGwNR"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ShopLogin/ShopLogin.scss
 ** module id = 1096
 ** module chunks = 0
 **/